export default {
  messages: require("./messages.json"),
  buttons: require("./buttons.json"),
  validations: require("./validations.json"),
  labels: require("./labels.json"),
  menus: require("./menus.json"),
  menuLottery: require("./menuLottery.json"),
};
